import { env } from 'env';

import { setCurrentWorldId } from '@helpers/currentWorld';

import { checkIsLocalhost } from '../../helpers/path';
import { customAppThemes } from '../../constants/eventStyles';
import WorldsService from '../../services/WorldsService';

const { REACT_APP_APP_THEME_HOST_NAME } = env;

export const getAppTheme = async () => {
  const isLocalhost = checkIsLocalhost();
  const hostname = isLocalhost
    ? (REACT_APP_APP_THEME_HOST_NAME as string)
    : window.location.hostname;

  if (!REACT_APP_APP_THEME_HOST_NAME && isLocalhost) {
    return customAppThemes.default();
  }

  const eventConfig = await WorldsService.getCustomStyles(hostname);

  if (eventConfig?.customStyles?.pageTitle) {
    const titleElement = document.getElementById('dynamic-title');
    if (titleElement) {
      const title = eventConfig.customStyles.pageTitle;
      titleElement.innerText = title;
      localStorage.setItem('app_metadata', JSON.stringify({ title }));
    }
  }

  if (eventConfig?.customStyles) {
    const colorTheme: string = eventConfig.customStyles?.colorTheme ?? 'light';
    //@ts-ignore
    return customAppThemes[colorTheme.toLowerCase()](eventConfig.customStyles);
  }

  return customAppThemes.default();
};

/**
 * Loads the project settings for the host the hub is served from.
 *
 * Also records the project id: the bootstrap call in `resolveCognitoParams`
 * normally sets it before the first render, and this second write heals the
 * value when that request failed.
 *
 * @returns The project settings, or `null` when the domain matches no project.
 */
export const getAppSettings = async () => {
  const isLocalhost = checkIsLocalhost();
  const hostname =
    isLocalhost && REACT_APP_APP_THEME_HOST_NAME
      ? (REACT_APP_APP_THEME_HOST_NAME as string)
      : window.location.hostname;

  const worldConfig = await WorldsService.getWorldSettings(hostname);

  // Only overwrite with a real id — a response without one must not clear what
  // bootstrap already resolved.
  if (worldConfig?.worldId) {
    setCurrentWorldId(worldConfig.worldId);
  }

  return worldConfig.settings || null;
};
